export const SERIES_STORAGE_KEY = 'mw_series_creating';

export const getSeriesCreationState = () => {
  try {
    const state = localStorage.getItem(SERIES_STORAGE_KEY);
    return state ? JSON.parse(state) : null;
  } catch (error) {
    console.error('Error reading series creation state:', error);
    return null;
  }
};

export const setSeriesCreationState = (state) => {
  try {
    if (state) {
      localStorage.setItem(SERIES_STORAGE_KEY, JSON.stringify(state));
    } else {
      localStorage.removeItem(SERIES_STORAGE_KEY);
    }
  } catch (error) {
    console.error('Error saving series creation state:', error);
  }
};

export const addCreatedEventToSeries = (logId, projectId, timecodeId) => {
  const state = getSeriesCreationState();
  if (state) {
    state.createdEvents.push({ logId, projectId, timecodeId, createdAt: Date.now() });
    setSeriesCreationState(state);
  }
};